module.exports = __webpack_public_path__ + "img/logo--vert.be292b07.svg";